var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.componentClass }, [
    _c("p", [_vm._v(_vm._s(_vm.widgetInfo.widgetDescription))]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row no-gutters text-center" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("button", { staticClass: "btn btn-primary" }, [
          _c("i", { staticClass: "fas fa-file-download" }),
          _vm._v(" "),
          _c("span", { staticClass: "ml-1", on: { click: _vm.exportCSV } }, [
            _vm._v("Download Template")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-4 no-gutters text-center" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("img", {
          staticClass: "upload-example",
          attrs: {
            width: "100%",
            height: "auto",
            src: require("../../assets/import-user-example.svg"),
            alt:
              "Required Information: First Name, Last Name, Email, User Role (Format: camel case w/ no spaces)",
            title:
              "Required Information: First Name, Last Name, Email, User Role"
          }
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v("Example: "),
          _c("span", { staticStyle: { color: "#BB0000" } }, [
            _vm._v("*Required Information")
          ]),
          _vm._v(" & Data Formatting")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41bb2882", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41bb2882","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/DownloadfileBlock.vue
// module id = null
// module chunks = 